
import React from 'react';
import text from '../../translation.json';
import './formError.scss';

const ValidationAlert = ({ content }) => {
return <div className="form-error">{text.contact.error} {content} {content === 'message' ? 'up to 500 characters' : null}</div>
}

export default ValidationAlert;